import React from 'react';
import { Segment, Dropdown, Input, Button, Form, Icon, Message } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { validateCityZip } from '../../util/helpers'

/**
 * New target component
 */
export default class NewTarget extends React.Component {

	actualHco;
	actualAddress;

	/**
     * Constructor
     * @param {*} props 
     */
    constructor(props) {
        super(props);

        this.state = {
			addressDisabled: true,
			hcoDisabled: true,
			hcos: [],
			validationError: null,
			professionType: null
        }
	}		

	handleCityChange = (e, { name, value }) => {
		this.setState((prevState) => ({ ...prevState, city: value, addressDisabled: false }))

		// Get address list by city
		this.props.fetchAddress(value);
		
		// Validate city-zip combination
		const postalCode = document.getElementById('postalCode').value;
		if (postalCode && value && this.props.cityZipData) {
			const validation = validateCityZip(value, postalCode, this.props.cityZipData);
			this.setState({ validationError: validation.valid ? null : validation.message });
		}
	}

	handleAddressChange = (e, { name, value }) => {
		this.actualAddress = value;
		this.actualHco = ''; // HINT we will populate this field later, while exporting

		// Get all distinct HCOs from the address list by value
		const hcos = [...new Set(this.props.address.filter(a => a.value === value).map(a => a.hco))];

		this.setState((prevState) => ({ ...prevState, hcos, hcoDisabled: false }))
	}
	
	handlePostalCodeChange = (e) => {
		const postalCode = e.target.value;
		
		// Validate city-zip combination
		if (this.state.city && postalCode && this.props.cityZipData) {
			const validation = validateCityZip(this.state.city, postalCode, this.props.cityZipData);
			this.setState({ validationError: validation.valid ? null : validation.message });
		}
	}

	handleHcoChange = (e, { name, value }) => {
		this.actualHco = value;
	}	

	handlePreferredSpecialtyChange = (e, { value }) => {
		var textContent = this.props.targetgroups.filter( tg => tg.value === value)[0].text;
		this.setState((prevState) => ({ ...prevState, mypreferredspecialtyen: value, mypreferredspecialtyhu: textContent }
	))}

	handleProfessionTypeChange = (e, { value }) => {
		this.setState({ professionType: value }, () => {
			// Re-validate license if already entered (after state update)
			const license = document.getElementById('stamp').value;
			if (license) {
				this.checkLicense(license);
			}
		});
	}

	/**
	 * Get validation message based on profession type
	 */
	getValidationMessage() {
		const professionType = this.state.professionType;
		
		switch(professionType) {
			case 'DOCTOR':
				return 'Pecsétszám érvénytelen! Orvos esetén érvényes formátum: 4-6 számjegy (pl. 12345)';
			case 'HEALTHCARE':
				return 'Pecsétszám érvénytelen! Szakdolgozó esetén érvényes formátum: 4-6 számjegy + SZD (pl. 12345SZD)';
			case 'PHARMACIST':
				return 'Pecsétszám érvénytelen! Gyógyszerész esetén érvényes formátum: 4-6 számjegy + GY (pl. 12345GY)';
			case 'PHARMACY_ASSISTANT':
				return 'Pecsétszám érvénytelen! Gyógyszertári asszisztens esetén érvényes formátum: 4-6 számjegy + GYA (pl. 12345GYA)';
			default:
				return 'Először válaszd ki a szakma típusát!';
		}
	}

	/**
	 * Init
	 */
	componentDidMount() {
		this.props.clearRequestUi();
		if (this.props.targetgroups.length === 0)
		{
			this.props.fetchTargetgroups();
		}
		if (this.props.cities.length === 0)
		{
			this.props.fetchCities();
		}
	}

	componentWillUnmount() {
		this.props.clearRequestUi();
	}

	/**
	 * Save new target request
	 */
	handleRequestAddNewTarget() {
		var visitorTerritory = this.props.visitorTerritory;
		var city = this.state.city;
		var segmentation = 'NA'; // No longer user-editable
		var mypreferredspecialtyen = this.state.mypreferredspecialtyen;
		var mypreferredspecialtyhu = this.state.mypreferredspecialtyhu;
		var postalCode = document.getElementById('postalCode').value;
		var stamp = document.getElementById('stamp').value;
		var name = document.getElementById('name').value;
		var address = this.actualAddress;
		var hco = this.actualHco;
		var professionType = this.state.professionType;

		if (!professionType) {
			alert('Szakma típusának kiválasztása kötelező!');
			return;
		}

		if (city === undefined || postalCode === undefined || address === undefined || stamp === undefined || mypreferredspecialtyen === undefined || mypreferredspecialtyhu === undefined || name === undefined)
		{
			alert('Minden adat megadása kötelező. Rendszerben már szereplő cím újra nem vihető fel.');
		}
		else
		{
			if (postalCode.length !== 4 || isNaN(postalCode))
			{
				alert('Irányítószámnak négy számból kell állnia.');
			}
			else
			{
				// Validate city-zip combination
				const validation = validateCityZip(city, postalCode, this.props.cityZipData);
				if (!validation.valid) {
					alert('Irányítószám és település nem egyezik!\n\n' + validation.message);
					return;
				}
				
				this.props.requestAddNewTarget(visitorTerritory, stamp, name, segmentation, mypreferredspecialtyen, mypreferredspecialtyhu, city, postalCode, address, hco)
			}
		}
	}	

	/**
	 * Check license formal validity.
	 */
	isValidLicense(license) {
		if (!this.state.professionType) {
			return false; // Profession type must be selected first
		}

		const professionType = this.state.professionType;
		
		// Doctor: 4-5-6 digits only
		if (professionType === 'DOCTOR') {
			const exp = /^[0-9]{4,6}$/;
			return exp.test(license);
		}
		// Healthcare professional: numbers + SZD
		else if (professionType === 'HEALTHCARE') {
			if (!license.endsWith('SZD')) {
				return false;
			}
			const numbers = license.replace('SZD', '');
			const exp = /^[0-9]{4,6}$/;
			return exp.test(numbers);
		}
		// Pharmacist: numbers + GY
		else if (professionType === 'PHARMACIST') {
			if (!license.endsWith('GY')) {
				return false;
			}
			const numbers = license.replace('GY', '');
			const exp = /^[0-9]{4,6}$/;
			return exp.test(numbers);
		}
		// Pharmacy assistant: numbers + GYA
		else if (professionType === 'PHARMACY_ASSISTANT') {
			if (!license.endsWith('GYA')) {
				return false;
			}
			const numbers = license.replace('GYA', '');
			const exp = /^[0-9]{4,6}$/;
			return exp.test(numbers);
		}
		
		return false;
	}

	/**
	 * Is it an existing record?
	 */
	checkLicense(license) {
		if (!this.isValidLicense(license))
		{
			this.setState({...this.state, invalidLicense: true});
		}
		else
		{
			this.setState({...this.state, invalidLicense: undefined});
			if (license !== undefined && license.length > 3)
			{
				this.props.requestCheckLicense(license);
			}
		}
	}

	render() {
		return  <Segment basic loading={ this.props.isLoading || this.props.isSaving }>
					<h3>Új célpont</h3>
					{ this.state.validationError ? <Message error><Icon name='warning sign' />{this.state.validationError}</Message> : '' }
                    { 
						this.props.error === undefined && this.props.message === undefined && this.props.checkLicense === undefined
						? 
						<Message warning>
							Korábban már rögzített pecsétszámmal új célpontot felvenni nem lehet. A célpont típusa és a pecsétszám megadása kötelező.
						</Message>
						:
						this.props.checkedLicense !== undefined
						?
						<Message
							info
							icon='user'
							header='Ismert orvos a rendszerben'
							content={ <span>{ this.props.message }
										<br/>
										<br/>
										<Link to={ '/addPanelTarget/' + this.props.visitorTerritory + '/' + this.props.checkedLicense }><Button compact primary>Orvos adatlap</Button></Link>									
									  </span> }
						/>						
						:
						this.props.message === undefined
						? 
						<Message error>Hiba történt. { this.props.error }</Message> 
						:
						''
					}
					{
						this.state.invalidLicense !== undefined
						?
						<Message error>
							{this.state.professionType ? this.getValidationMessage() : 'Először válaszd ki a szakma típusát!'}
						</Message>
						:
						''
					}
					<Form>
						<Form.Field required>
							<label>Szakma típusa</label>
							<Dropdown
								placeholder='Válassz szakma típust'
								id='professionType'
								fluid
								selection
								onChange={ this.handleProfessionTypeChange }
								options={ [
									{ key: 'DOCTOR', value: 'DOCTOR', text: 'Orvos' },
									{ key: 'HEALTHCARE', value: 'HEALTHCARE', text: 'Szakdolgozó' },
									{ key: 'PHARMACIST', value: 'PHARMACIST', text: 'Gyógyszerész' },
									{ key: 'PHARMACY_ASSISTANT', value: 'PHARMACY_ASSISTANT', text: 'Gyógyszertári asszisztens' }
								] }
							/>
						</Form.Field>
						<Form.Field required>
							<label>Pecsétszám</label>
							<Input onChange={ (e) => this.checkLicense(e.target.value) } id='stamp'/>
						</Form.Field>						
					<Form.Field required>
						<label>Orvos neve</label>
						<Input id='name'/>
					</Form.Field>	
					<Form.Field required>
						<label>Új szakterület</label>
						<Dropdown search
								  selection 
								  onChange={ this.handlePreferredSpecialtyChange } 
								  options={this.props.targetgroups} 
								  item />
					</Form.Field>		
					<Form.Field required>
						<label>Irányítószám</label>
						<Input id='postalCode' onChange={this.handlePostalCodeChange} />
					</Form.Field>
						<Form.Field required>
							<label>Település</label>
							<Dropdown
								placeholder='Kezd el beírni a település nevét'
								id='city'
								fluid
								search
								selection
								onChange={ this.handleCityChange }
								options={ this.props.cities }
							/>
						</Form.Field>
						<Form.Field required>
							<label>Utca, házszám</label>
							<Dropdown
								disabled={this.state.addressDisabled}
								placeholder='Kezd el beírni a cím nevét'
								id='address'
								fluid
								search
								onChange={ this.handleAddressChange }
								selection
								options={ Array.from(new Set(this.props.address.map(addr => addr.value))).map((value, index) => ({ key: index, value: value, text: value })) }
							/>
						</Form.Field>
						<Form.Field>
							<label>Intézmény</label>
							<Dropdown
								disabled={this.state.hcoDisabled}
								placeholder='Válassz intézményt'
								id='hco'
								fluid
								search
								onChange={ this.handleHcoChange }
								selection
								options={ this.state.hcos.map(hco => ({ key: hco, value: hco, text: hco })) }
							/>
						</Form.Field>						
						<Link to='/panelChanges'><Button basic primary>Mégse</Button></Link>
						<Button disabled={ this.state.invalidLicense !== undefined || !this.state.professionType } onClick={ () => this.handleRequestAddNewTarget() } floated='right' primary><Icon name='check' /> Mentés</Button>
					</Form>					
				</Segment>
	}
}